import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

type SortOption = 'newest' | 'oldest' | 'alphabetical';

export const PortfolioSort = ({ 
  onSort 
}: { 
  onSort: (value: SortOption) => void 
}) => {
  return (
    <div className="w-full md:w-auto">
      <Select onValueChange={onSort}>
        <SelectTrigger className="w-[180px] rounded-full border-2 border-purple-600/30 bg-white text-purple-900 hover:border-purple-600/50 focus:ring-2 focus:ring-purple-600/20">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent className="bg-white border-2 border-purple-600/30 rounded-lg shadow-lg">
          <SelectItem value="newest" className="hover:bg-purple-600/10 focus:bg-purple-600/10">Newest first</SelectItem>
          <SelectItem value="oldest" className="hover:bg-purple-600/10 focus:bg-purple-600/10">Oldest first</SelectItem>
          <SelectItem value="alphabetical" className="hover:bg-purple-600/10 focus:bg-purple-600/10">A-Z</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
